/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import SearchBar from 'bundles/search-common/components/searchbar/SearchBar';

const styles = {
  searchBar: css`
    && {
      width: 100%;

      .rc-SearchBar {
        max-width: 480px;
        min-width: 0;
        width: 100%;
      }
    }
  `,
};

const ConsumerSearchBarGridItem = () => {
  return (
    <div css={styles.searchBar}>
      <SearchBar />
    </div>
  );
};

export default ConsumerSearchBarGridItem;
